import React, { useState } from 'react';
import Modal from '../../../../../component/modal/Modal';
import Button from '../../../../../component/ui/Button';
import { changeAccountStatus } from '../../../../../services/settings/accounting';
import { toast } from 'react-toastify';

export default function ActivateAccountModal({
	isOpenModal,
	setIsOpenModal,
	accountId,
	getAccountDetails,
}) {
	const [loader, setLoader] = useState(false);
	const handleActivateAccount = async () => {
		try {
			setLoader(true);
			const body = {
				status: 1,
			};
			const res = await changeAccountStatus(accountId, body);
			if (res.success) {
				toast.success(res.message);
				setIsOpenModal(false);
				getAccountDetails();
			} else {
				toast.error(res.message || 'something went wrong!');
			}
		} catch (err) {
			toast.error(err.message || 'Something went wrong!');
		} finally {
			setLoader(false);
		}
	};

	return (
		<Modal
			className="confirmatinBoxModal"
			title={'Activate Account'}
			isOpen={isOpenModal}
			onClose={() => {
				setIsOpenModal(false);
			}}
			cancelButton={() => {
				setIsOpenModal(false);
			}}
		>
			<div className="fs-4 fw-bold text-center">
				Are you sure you want to activate this account?
			</div>
			<div
				className="fs-4 fw-semibold text-center py-2"
				style={{ color: '#979797' }}
			>
				This account will be available for use in new transactions again.
			</div>
			<div className="d-flex align-items-center justify-content-end mt-4 gap-4">
				<Button
					type="button"
					button={`Cancel`}
					className="mt-0 px-4 btn-gray relative"
					onClick={() => {
						setIsOpenModal(false);
					}}
				/>
				<Button
					type="button"
					button={`Activate`}
					loader={loader}
					disabled={loader}
					className="mt-0 px-4 btn-primary relative"
					onClick={() => handleActivateAccount()}
				/>
			</div>
		</Modal>
	);
}
